import PlanGroupDetails, { FeatureTable, GroupFeature } from './PlanGroupDetails';

export { FeatureTable, GroupFeature };
export default PlanGroupDetails;
